import { render, staticRenderFns } from "./materialDeploy.vue?vue&type=template&id=2acb2b30&scoped=true&"
import script from "./materialDeploy.vue?vue&type=script&lang=js&"
export * from "./materialDeploy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acb2b30",
  null
  
)

export default component.exports